import _ from 'lodash'
import codes from '@/f1/codes'
import VueApexCharts from 'vue-apexcharts'

// 여기의 컨셉은 모든 설정을 한번에 다 하는 컨셉
export default {
  components: {
    VueApexCharts
  },
  name: 'RuleQuick',
  props: ['now_policy'],
  watch: {
  },
  data: () => {
    return {
      // 신규
      level : 1,
      mode : 1,
      info : {
        chart : {
          policy : {
            title : { text: '', align : 'center', show : false },
            series : [],
            option : {
              colors : [codes.WAF_MODE_TO_COLOR(0, 'hex'), codes.WAF_MODE_TO_COLOR(1, 'hex'), codes.WAF_MODE_TO_COLOR(2, 'hex')],
              labels : [],
              legend: {
                fontWeight : 800,
                position: 'bottom',
                fontSize: '18pt',
              }
            }
          },
          color : {
            NORMAL : '#339BFB',
            WARNING : '#FFC90E',
            DANGER : '#F44336',
          },
        },
      },

      modal_save : false,
      step : 1,
      all : 2,
    }
  },
  computed: {},
  methods: {
    // 신규
    refresh_custom_crs() {
      // off, detect, block
      this.info.chart.policy.series = [0, 0, 0]

      for (let l = 0; l < this.now_policy.custom_crs.length; l++) {

        this.now_policy.custom_crs_dic[this.now_policy.custom_crs[l].key] = this.now_policy.custom_crs[l]

        // 제외 정책
        if(this.now_policy.custom_crs[l].key.startsWith('903.')) {
          // this.info.chart.policy.series[0] += this.now_policy.custom_crs[l].policy_list.length
          continue
        }

        // 이용 불가 정책
        if(!this.now_policy.custom_crs[l].is_available) { continue }

        console.log('this.level', this.level)

        _.forEach(this.now_policy.custom_crs[l].policy_list, p => {
            // 이용 불가 정책
          if(!p.is_available) { return }

          if(p.level > 1) { return }

          switch (Number(this.level)) {
            case 0:
              this.info.chart.policy.series[0] += 1;

              break;
            case 1:
              if(p.level > 1) { this.info.chart.policy.series[0] += 1; }
              else {
                this.info.chart.policy.series[1] += 1;
              }
              break

            case 1.5:
              this.info.chart.policy.series[1] += 1;

              break;
            case 2:
              if(p.level > 1) { this.info.chart.policy.series[1] += 1; }
              else {
                this.info.chart.policy.series[2] += 1;
              }

              break;
            case 3:
              if(p.level > 2) {
                this.info.chart.policy.series[1] += 1;
              } else {
                this.info.chart.policy.series[2] += 1
              }

              break;
            case 4: this.info.chart.policy.series[2] += 1; break;
          }
        })
      }
    },
    change_level(val) {
      this.level = val
      this.refresh_custom_crs()
    },

    // 이전
    apply() {
      try {
        // 레벨에 따른 정책 빌드 후 저장
        let build_policy = this.now_policy

        for (let l = 0; l < build_policy.custom_crs.length; l++) {

          build_policy.custom_crs_dic[build_policy.custom_crs[l].key] = build_policy.custom_crs[l]
          if(!build_policy.custom_crs[l].is_available) { continue }

          // 제외 정책
          if(build_policy.custom_crs[l].key.startsWith('903.')) {
            _.forEach(build_policy.custom_crs[l].policy_list, x => {
              x.mode = codes.WAF_MODE_OFF.VALUE
            })
            continue
          }

          // console.log('this.level', this.level)

          _.forEach(build_policy.custom_crs[l].policy_list, p => {
            if(!p.is_available) { return }
            if(p.level > 1) { return }

            switch (Number(this.level)) {
              case 0:
                p.mode = codes.WAF_MODE_OFF.VALUE
                break;
              case 1:
                p.mode = p.level > 1 ? codes.WAF_MODE_OFF.VALUE : codes.WAF_MODE_DETECTIONONLY.VALUE
                break;
              case 1.5:
                p.mode = codes.WAF_MODE_DETECTIONONLY.VALUE
                break;
              case 2:
                p.mode = p.level > 1 ? codes.WAF_MODE_DETECTIONONLY.VALUE : codes.WAF_MODE_ON.VALUE
                break;
              case 3:
                p.mode = p.level > 2 ? codes.WAF_MODE_DETECTIONONLY.VALUE : codes.WAF_MODE_ON.VALUE
                break
              case 4:
                p.mode = codes.WAF_MODE_ON.VALUE
                break;
            }
          })
        }

        // 저장 시그널 전송
        this.$parent.$emit('save', Object.assign({}, this.now_policy, build_policy))
      } catch (e) { console.log(e); this.$toastr.e("load error #1") }
    },
    list() { this.$router.push({ name: 'webcastle_agent'}); },
    next(step = '') {
      if(step) { this.step = step }
      else { this.step = this.step >= this.all ? this.all : this.step + 1 }
    },
    prev(step = '') {
      if(step) { this.step = step }
      else { this.step = this.step <= 0 ? 1 : this.step - 1 }
    },
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
      this.$forceUpdate()
    },

    load() {
      try {
        this.info.chart.policy.option.labels = _.map(codes.WAF_MODE, x => codes.WAF_MODE_I18N(x, this.i18n || 'EN'))
        this.refresh_custom_crs()

      } catch (e) { console.log(e); this.$toastr.e("load error #4") }
    },
  },
  created: function() {   console.log('RuleQuick.vue', 'created'); },
  destroyed: function() { console.log('RuleQuick.vue', 'destroyed'); },
  mounted: function() {
    console.log('RuleQuick.vue', 'mounted');
    this.load()
  }
}
